/********************************************************************/
/* Based on                                                         */
/* https://css-tricks.com/the-complete-guide-to-lazy-loading-images */
/* with custom buffering and background-images handling.            */
/********************************************************************/

// WHEN NOT TO USE: Probably on above the fold images or if you only have one image on the page.
//      or you don't want eager buffering of images that will never be seen on mobile.
//      Buffer could download images that will never be visible.
//      Consider if native loading="lazy" will perform better in those circumstances.
// USAGE: data-src="image.jpg"
//        OR data-srcset="small.jpg 300w, large.jpg 1000w"
// NOTE: May be easier to test on a 1080p HD display.
//       If you're getting unexpected results you may be testing on a retina or high devicePixelRatio device.

// Some buffering solutions have suggested offset the intersectionObserver margin
// but that creates a double scroll bars bug if your view height is smaller than your container.

// This solution uses the lazyloadImages array to track progress and buffer n additional image requests to give them a chance of completing before they come into view.

// this will also load background images with class ".lazy".

import Component from './Component';

export default class LazyImages extends Component {

  load() {
    this.intersectionObservers = [];
    this.initLazyImages();
    this.watchDOM();
    super.load();
  }

  initLazyImages() {

    // console.log('LazyImages observing');

    // console.log('intersectionObservers.length: ', this.intersectionObservers.length);
    //disconnect any previous observers
    if (this.intersectionObservers.length > 0) {
      this.intersectionObservers.forEach(observer => {
        observer.disconnect();
        // console.log('disconnect observer');
      });
    }
    this.intersectionObservers = []; // clear the array after old intersectionObservers have been disconnected



    var lazyloadImages;
    var buffer = 1; // initially buffer n images ahead
    var bufferMax = 30;

    if ("IntersectionObserver" in window) {
      lazyloadImages = document.querySelectorAll(".lazy");
      var imageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            lazyloadImages.forEach(function (item, index) {
              var theItem = item.dataset.src + "";
              debugLog('item: ', item);  // item is an element with a class ".lazy"
              // debugLog('theItem: ', theItem);
              // debugLog('entry.target.dataset.src: ', entry.target.dataset.src);

              if (theItem.includes(entry.target.dataset.src)) {
                for (
                  let i = index;
                  i < lazyloadImages.length && i < index + buffer;
                  i++
                ) {
                  // create a reference to the image
                  const image = lazyloadImages[i];

                  if (!image.classList.value.includes("lazied")) {
                    if (image.dataset) {
                      // if it has data-src or data-srcset
                      debugLog('image.dataset', image.dataset);

                      // handle background images that have the .bgimage class
                      if (image.classList.value.includes("bgimage")) {
                        // console.log(i, ": bgimage");
                        if (image.dataset.holdersrc) {
                          image.style["background-image"] =
                          "url('" + image.dataset.src + "'), url('" + image.dataset.holdersrc + "')";
                        } else {
                          image.style["background-image"] =
                          "url('" + image.dataset.src + "')";
                        }
                      } else {
                        // handle regular images
                        // console.log(i, ": img");
                        // debugLog('image.dataset.src', image.dataset.src);

                        if (image.dataset.src) {
                          // console.log('HERE1');
                          image.src = image.dataset.src;
                        }
                        // image.src = image.dataset.src;
                        if (image.dataset.srcset) {
                          // console.log('HERE2');
                          image.srcset = image.dataset.srcset;
                        }
                      }
                      image.classList.add("lazied");
                    }
                  }
                  if (i == index) {
                    //only unobserve when the image intersects
                    image.classList.remove("lazy");
                    // console.log("unobserve: ", i);
                    imageObserver.unobserve(image);
                    if (buffer < bufferMax) {
                      buffer++;  //accellerating buffer
                    }
                  }
                }
              }
            });
          }
        });
      });

      if (imageObserver != 'undefined') {
        this.intersectionObservers.push(imageObserver);
        // console.log('observer pushed.');
      }


      lazyloadImages.forEach(function (image) {
        imageObserver.observe(image);
      });
    }

  }

  watchDOM() {
    // Watch for DOM changes, i.e. from Search

    var self = this;
    // console.log('watchDOM');

    // Select the node that will be observed for mutations
    const targetNode = document.getElementById('result-grid');

    if (typeof targetNode == 'object' && targetNode != null) {
      // console.log('one', targetNode);

      // Options for the observer (which mutations to observe)
      const config = { attributes: false, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      const callback = function(mutationsList, observer) {
          for(const mutation of mutationsList) {
              if (mutation.type === 'childList') {
                  // console.log('Observed result-grid change.');
                  self.initLazyImages();
              }
              else if (mutation.type === 'attributes') {
                  // console.log('The ' + mutation.attributeName + ' attribute was modified.');
              }
          }
      };
      // console.log('two');

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);

      // console.log('three');
      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);

    }
    // console.log('done');

  }
}

